'use client';

import React, { useState } from 'react';

import { useServerInsertedHTML } from 'next/navigation';

import { ServerStyleSheet, StyleSheetManager } from 'styled-components';

/**
 * Collects the styled-components CSS a server render produces and streams it
 * into the document ahead of the markup that needs it.
 *
 * Without this the server sends styled elements with their class names but no
 * stylesheet, and the client, hydrating, injects the CSS under its own class
 * names; React keeps the server's attributes, so the two never meet and the
 * header, cards and popups render unstyled. The deterministic component ids
 * come from `compiler.styledComponents` in next.config.
 */
export const StyledComponentsRegistry = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  const [sheet] = useState(() => new ServerStyleSheet());

  useServerInsertedHTML(() => {
    const styles = sheet.getStyleElement();
    sheet.instance.clearTag();

    return <>{styles}</>;
  });

  if (typeof window !== 'undefined') {
    return <>{children}</>;
  }

  return <StyleSheetManager sheet={sheet.instance}>{children}</StyleSheetManager>;
};
